import { useSuspenseQuery } from '@apollo/client';
import React from 'react';

import { SettingsEditableValue } from '@eluve/blocks';
import {
  DEFAULT_UI_LANGUAGE,
  SUPPORTED_UI_LANGUAGES,
  type UiLanguageCode,
  isUiLanguageCode,
} from '@eluve/i18n';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';

import { InterfaceLanguageDialog } from './InterfaceLanguageDialog';
import { getTenantDefaultUiLanguageQuery } from './operations';

export const InterfaceLanguageSettings: React.FC = () => {
  const tenantId = useAssignedTenantIdFromParams();

  const { data } = useSuspenseQuery(getTenantDefaultUiLanguageQuery, {
    variables: { tenantId },
  });

  const rawUiLanguage = data.defaultTenantUserSettingsByPk?.uiLanguage;
  const currentUiLanguage: UiLanguageCode = isUiLanguageCode(rawUiLanguage)
    ? rawUiLanguage
    : DEFAULT_UI_LANGUAGE;

  const currentLabel =
    SUPPORTED_UI_LANGUAGES.find((option) => option.code === currentUiLanguage)
      ?.nativeLabel ?? currentUiLanguage;

  return (
    <SettingsEditableValue
      value={currentLabel}
      editLabel="Edit interface language"
      renderDialog={({ open, onOpenChange }) => (
        <InterfaceLanguageDialog
          open={open}
          onOpenChange={onOpenChange}
          tenantId={tenantId}
          currentUiLanguage={currentUiLanguage}
        />
      )}
    />
  );
};
